import { v4 as uniqueId } from 'uuid';

export const SWATCH_COLORS = [
  { id: uniqueId(), color1: '#FFC0CB', color2: '#FF69B4', color3: '#FF1493' },
  { id: uniqueId(), color1: '#DC143C', color2: '#A52A2A', color3: '#8B0000' },
  { id: uniqueId(), color1: '#FFA500', color2: '#FF6347	', color3: '#FF4500' },
  { id: uniqueId(), color1: '#fcff5d', color2: '#FFFF00	', color3: '#FFD700' },
  { id: uniqueId(), color1: '#FFA500', color2: '#f47a22	', color3: '#D2691E' },
  { id: uniqueId(), color1: '#DA70D6', color2: '#FF00FF', color3: '#8B008B' },
  { id: uniqueId(), color1: '#00BFFF', color2: '#0000FF', color3: '#00008B	' },
  { id: uniqueId(), color1: '#00FFFF', color2: '#40E0D0', color3: '#008B8B' },
  { id: uniqueId(), color1: '#7CFC00', color2: '#0ec434', color3: '#008000' },
  { id: uniqueId(), color1: '#D3D3D3', color2: '#808080', color3: '#000000' },
];
